<template>
  <CardFormLayout card-title="Please Login">
    <template #fields>
      <EmailField v-model="email" />
      <PasswordField v-model="password" />
      <v-text-field
        v-if="isOtpShown"
        v-model="otp"
        label="OTP"
        placeholder="Enter OTP"
      />
    </template>
    <template #actions>
      <SubmitButton
        :loading="isLoaderShown"
        :disabled="isDisabled"
        @click="submit"
      >
        Login
      </SubmitButton>
    </template>
  </CardFormLayout>
</template>
<script lang="ts" setup>
  import { ref, computed } from 'vue';
  // import components
  import CardFormLayout from '@/components/Layouts/CardFormLayout.vue';
  import EmailField from '@/components/EmailField.vue';
  import PasswordField from '@/components/PasswordField.vue';
  import SubmitButton from '@/components/SubmitButton.vue';

  const email = ref('');
  const password = ref('');
  const otp = ref('');

  const props = defineProps({
    passwordRules: {
      type: undefined,
      default: () => [(v: string) => !!v || 'Password is required'],
    },
    usernameRules: {
      type: undefined,
      default: () => [
        (v: string) => !!v || 'Email is required',
        (v: string) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    },
    isLoaderShown: {
      type: Boolean,
      default: false,
    },
    isOtpShown: {
      type: Boolean,
      default: false,
    },
  });

  let emit = defineEmits(['onLogIn']);

  let submit = () => {
    emit('onLogIn', {
      email: email.value,
      password: password.value,
      otp: otp.value,
    });
  };

  let isDisabled = computed(() => {
    // check if passwordRules and usernameRules is boolean and if its true only then return false
    return (
      !props.passwordRules.every((rule) => rule(password.value) === true) ||
      !props.usernameRules.every((rule) => rule(email.value) === true)
    );
  });
</script>
